export type PAX = {
  adults: number;
  babies: number;
  children: number;
};

export const DEFAULT_ADULTS_PAX = 2;
export const DEFAULT_SOLO_ADULT = 1;
